import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01c36ec4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "informatics_health_needs" }
const _hoisted_2 = { class: "container-lg container-fluid py-4 px-lg-5 px-3" }
const _hoisted_3 = { class: "card border-0 shadow" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "card-header h5 py-4" }, "Health Needs - Pending Publishing", -1))
const _hoisted_5 = {
  key: 0,
  class: "card-body list"
}
const _hoisted_6 = {
  key: 1,
  class: "px-3"
}
const _hoisted_7 = {
  key: 2,
  class: "card-body list"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "border-0 h-75 d-flex align-items-center justify-content-center" }, " No Pending Approvals ", -1))
const _hoisted_9 = [
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HealthNeed = _resolveComponent("HealthNeed")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_PublishNeed = _resolveComponent("PublishNeed")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_HealthNeed, { user: "informatics" }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        (!_ctx.needLoading && _ctx.getHealthNeeds.length > 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getHealthNeeds, (item, i) => {
                return (_openBlock(), _createElementBlock("li", { key: i }, [
                  _createElementVNode("span", null, _toDisplayString(item?.title), 1),
                  _createVNode(_component_Button, {
                    onClick: ($event: any) => (_ctx.gotoApproveNeed(item.id)),
                    label: "Publish",
                    class: "p-button-sm p-button-primary py-2",
                    "aria-label": "Publish"
                  }, null, 8, ["onClick"])
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.needLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
                return _createVNode(_component_Skeleton, {
                  width: "100%",
                  height: "3rem",
                  class: "mb-3",
                  key: i
                })
              }), 64))
            ]))
          : _createCommentVNode("", true),
        (!_ctx.needLoading && _ctx.getHealthNeeds.length === 0)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_7, _hoisted_9))
          : _createCommentVNode("", true)
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.healthNeedDialog,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.healthNeedDialog) = $event)),
      style: { width: '70rem' },
      header: "Approve Health Needs",
      modal: true,
      dismissableMask: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_PublishNeed, {
          ApproveId: _ctx.id,
          layout: false,
          modal: true,
          onClose: _ctx.closeHealthNeedDialog
        }, null, 8, ["ApproveId", "onClose"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}